<template>
  <div class="plan-table-container">
    <el-table
      :data="tableData"
      class="fixed-height-table"
      stripe
      border
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column prop="profession" label="专业" min-width="100" />
      <el-table-column prop="mozu" label="模组" min-width="100" />
      <el-table-column prop="strategy_name" label="维护对象" min-width="120" />
      <el-table-column prop="maintain_type" label="维护类型" min-width="100" />
      <el-table-column prop="maintain_period" label="维护周期" min-width="100" />
      <el-table-column prop="maintenance_ticket_type" label="维护策略" min-width="100" />
      <el-table-column prop="plan_start_time" label="计划开始时间" min-width="150" />
      <el-table-column prop="plan_end_time" label="计划结束时间" min-width="150" />
      <el-table-column prop="plan_end_time" label="设备清单" min-width="150">
        <template #default="scope">
          <maintenanceObjCheck :TableList="DataList" :index="scope.$index" />
        </template>
      </el-table-column>
      <el-table-column prop="device_num" label="设备数量" min-width="150" />
            <!-- 维护方列 - 下拉选择框 -->
      <el-table-column prop="to_maintainer" label="维护方" min-width="120">
        <template #default="{ row }">
          <el-select
            v-model="row.to_maintainer"
            placeholder="请选择维护方"
            size="small"
            filterable
            :disabled="!isEdit"
            @change="handleMaintenancePartyChange(row)"
          >
            <el-option label="服务商" value="服务商" />
            <el-option label="自维" value="自维" />
          </el-select>
        </template>
      </el-table-column>
      <!-- 服务商选择列 - 根据维护方选择动态显示 -->
      <el-table-column prop="SupplierId" label="服务商选择" min-width="120">
        <template #default="{ row }">
          <el-select
            v-if="row.to_maintainer == '服务商'"
            v-model="row.SupplierId"
            placeholder="请选择服务商"
            size="small"
            filterable
            :disabled="!isEdit"
            @change="handleSupplierChange(row)"
          >
            <el-option
              v-for="(supplier, index) in supplierList"
              :key="index"
              :label="supplier.label"
              :value="supplier.value"
            />
          </el-select>
          <span v-else-if="row.to_maintainer == '自维'">-</span>
          <span v-else></span>
        </template>
      </el-table-column>

      <el-table-column prop="position" label="职位" min-width="100">
        <template #default="{ row }">
          <el-select
            v-if="row.to_maintainer == '服务商'"
            v-model="row.position"
            placeholder="请选择职位"
            size="small"
            filterable
            :disabled="!isEdit"
            @change="handlePositionChange(row)"
          >
            <el-option label="园区PM" value="园区PM" />
            <el-option label="交付经理" value="交付经理" />
          </el-select>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column prop="account" label="接单人" min-width="150">
        <template #default="scope ">
          <UserSelect
            v-if="scope.row.to_maintainer == '服务商'"
            :selected="scope.row.account"
            :disabled="!isEdit"
            @child-click="clicks"
            @user-select-change="userSelectChange($event,scope.$index)"
          />
          <span v-else></span>
        </template>
      </el-table-column>
      
      <!-- 删除操作列 -->
      <el-table-column label="操作" min-width="100">
        <template #default="{ row, $index }">
          <el-button
            v-if="isEdit"
            type="danger"
            size="small"
            @click="handleDelete(row, $index)"
          >
            驳回
          </el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { GetSupplierList, getDealer } from '@/api/maintenance/maintenanceApi';
import UserSelect from '@/components/Formily/userSelect';
import maintenanceObjCheck from './maintenanceObjCheck.vue';
export default {
  name: 'PlanTable',
  props: ['DataList', 'campusName', 'isEdit'],
  components: { UserSelect, maintenanceObjCheck },
  data() {
    return {
      tableData: [],
      supplierList: [], // 服务商列表
      del_calendar_data: [], // 存储删除的日历数据
    };
  },

  created() {
    this.getSupplierList();
  },
  watch: {
    DataList: {
      handler(val) {
        if (val && val.length > 0) {
          this.tableData = val.map((item) => {
            const rowData = { ...item, SupplierId: item.SupplierId * 1 };
            const maintainer = rowData.to_maintainer;
            if (maintainer == '自维') {
              rowData.SupplierId = '';
              rowData.position = '';
              rowData.account = '';
            }
            return rowData;
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    clicks(val) {
      console.log(val, 'clicks');
    },
    userSelectChange(val,index) {
      console.log(val,index, 'userSelectChangess');
      this.tableData[index].account = val;
      this.$emit('allAdd', this.tableData, this.del_calendar_data);
    },
    // 获取服务商列表
    async getSupplierList() {
      try {
        const result = await GetSupplierList();
        if (result.status == 0) {
          this.supplierList = result.data.map((item) => ({
            label: item.label,
            value: item.value * 1,
          }));
        }
      } catch (error) {
        // 如果接口失败，使用空列表避免渲染错误
        this.supplierList = [];
      }
    },

    // 处理维护方选择变化
    handleMaintenancePartyChange(row) {
      // 当维护方选择"自维"时，清空服务商选择、职位和接单人
      if (row.to_maintainer == '自维') {
        row.SupplierId = '';
        row.position = '';
        row.account = '';
      }
      this.$emit('allAdd', this.tableData, this.del_calendar_data);
    },

    // 处理职位选择变化
    async handlePositionChange(row) {
      if (row.position && row.SupplierId) {
        try {
          const params =
            row.position === '园区PM'
              ? [row.position, row.SupplierId.toString(), this.campusName]
              : [row.position, row.SupplierId.toString()];

          const result = await getDealer(...params);
          if (result.status === 0) {
            row.account = result.data;
          }
        } catch (error) {
          // 静默处理错误
        }
        this.$emit('allAdd', this.tableData, this.del_calendar_data);
      }
    },

    // 处理服务商选择变化
    async handleSupplierChange(row) {
      if (row.to_maintainer === '服务商' && row.SupplierId) {
        row.position = '园区PM';

        try {
          const res = await getDealer('园区PM', row.SupplierId.toString(), this.campusName);
          if (res.status === 0 && res.data) {
            row.account = res.data;
          } else {
            row.position = '交付经理';
            const result = await getDealer('交付经理', row.SupplierId.toString());
            if (result.status === 0) {
              row.account = result.data;
            }
          }
        } catch (error) {
          // 静默处理错误，避免阻塞UI
        }
        this.$emit('allAdd', this.tableData, this.del_calendar_data);
      }
    },

    // 处理删除操作
    handleDelete(row, index) {
      this.$confirm('确定要驳回这条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 将删除的内容存入del_calendar_data
        this.del_calendar_data.push({
          ...row,
          delete_time: new Date().toISOString(),
          delete_index: index
        });
        
        // 从tableData中移除该行
        this.tableData.splice(index, 1);
        
        // 通知父组件数据变化
        this.$emit('allAdd', this.tableData, this.del_calendar_data);
        
        this.$message.success('驳回成功');
      }).catch(() => {
        // 用户取消删除
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.plan-table-container {
  width: 100%;
  height: 100%;

  .fixed-height-table {
    // 固定高度设置
    height: 400px; // 可以根据需要调整高度
    max-height: 400px;
    overflow: auto;

    // 表格样式优化
    :deep(.el-table__body-wrapper) {
      overflow-x: hidden;
    }

    :deep(.el-table__header-wrapper) {
      position: sticky;
      top: 0;
      z-index: 2;
    }

    // 表格行样式
    :deep(.el-table__row) {
      &:hover {
        background-color: #f5f7fa;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .plan-table-container {
    .fixed-height-table {
      height: 300px;
      max-height: 300px;
    }
  }
}
</style>